export default __webpack_public_path__ + "svg/calendar/2027/6/octubre.svg?87788587";